import { render } from "./Profile.vue?vue&type=template&id=eaf5e008&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"

import "./Profile.vue?vue&type=style&index=0&id=eaf5e008&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-eaf5e008"

export default script